import { useEffect, useState } from "react";
import { coperturaVisibile, osservaCopertura } from "@/lib/aperturaOfferta";

/**
 * Pannello opaco che copre lo schermo durante l'apertura di una pagina offerta.
 *
 * Sta qui, fuori dalle rotte, perché deve sopravvivere al cambio di pagina: viene
 * alzato mentre la pagina vecchia è ancora montata e tolto dalla pagina offerta
 * quando è pronta. Vedi src/lib/aperturaOfferta.ts per il perché.
 *
 * `fixed` e senza transizione in entrata: deve essere opaco già al primo frame,
 * altrimenti il salto si vede attraverso. In uscita sfuma, così la pagina offerta
 * non appare di colpo.
 */
export function CoperturaApertura() {
  const [visibile, setVisibile] = useState(coperturaVisibile);

  useEffect(() => osservaCopertura(setVisibile), []);

  return (
    <div
      aria-hidden
      className={`fixed inset-0 z-[100] bg-appBg transition-opacity duration-200 ${
        visibile ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    />
  );
}
